import { graphql } from "relay-runtime"

export const deEpisodeOfCareFragment = graphql`
  fragment deEpisodeOfCareFragment on de_EpisodeOfCare {
    id
    isVirtual
    icdDiagnosis {
      id
      isAssociation
      diagnosisCode
      primaryCode
      secondaryCode
      associationType
      text
    }
    patientId
    createdBy
    createdAt
    updatedAt
    isUpdatable
    progressNotes(first: null) @connection(key: "EpisodeOfCareProgressNotesConnection_progressNotes") {
      edges {
        node {
          ...deProgressNoteFragment @relay(mask: false)
          ...deProgressNoteFragment
        }
      }
    }
    relatedConditions {
      id
      icdDiagnosis {
        id
        isAssociation
        diagnosisCode
        primaryCode
        secondaryCode
        associationType
        text
      }
    }
  }
`
